import FormSelectBox from '@/views/components/Inputs/FormSelectBox';
import { useSelector } from 'react-redux';
import { useGetShipmentOriginators } from '../../hooks';

export const ShipmentOriginatorsSelect = ({
  placeholder = 'Select shipment originator',
  label = 'Shipment Originator',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const customerKey = useSelector((state) => state.auth.selectedCompany?.companyId);
  const { data: options = [], isLoading } = useGetShipmentOriginators(customerKey);

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      defaultOptions
    />
  );
};
